/* PDP -ugc1 "See it from real customers" roll + cross-review lightbox.
   Fetches curated media from the UGC Media Worker
   (priority/recent first), and wires a height-capped lightbox whose review
   card scrolls so the full text is always readable. Vanilla, no deps. */
(function () {
  'use strict';

  var UGC_MEDIA_WORKER = 'https://cakemiami-ugc-media.pavlovacake305.workers.dev';
  var FETCH_TIMEOUT_MS = 2500;

  function sizeImg(url, w) {
    // imgix review URLs carry ?w=NNNN; right-size them. Other hosts pass through.
    return url && /[?&]w=\d+/.test(url) ? url.replace(/w=\d+/, 'w=' + w) : url;
  }
  function stars(n) {
    var c = Math.max(0, Math.min(5, Math.round(Number(n) || 0)));
    return '★★★★★'.slice(0, c) + '☆☆☆☆☆'.slice(0, 5 - c);
  }
  function fmtDate(v) {
    if (!v) return '';
    var d = new Date(v);
    return isNaN(d.getTime()) ? String(v) : d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }
  function dateTime(v) {
    var t = v ? new Date(v).getTime() : 0;
    return isNaN(t) ? 0 : t;
  }
  function fetchJson(url) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, FETCH_TIMEOUT_MS) : null;
    return fetch(url, { cache: 'no-store', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .finally(function () { if (timer) clearTimeout(timer); })
      .catch(function () { return null; });
  }
  function pushUnique(items, seen, item) {
    if (!item.photo || seen[item.photo]) return;
    seen[item.photo] = true;
    items.push(item);
  }
  function mediaToItem(media) {
    var review = media && media.review ? media.review : {};
    var submittedAt = review.submitted_at || media.review_submitted_at || media.media_created_at;
    return {
      photo: media.image_url,
      name: window.transformReviewName(review.reviewer_display_name, ''),
      rating: review.rating,
      text: review.review_text || '',
      date: fmtDate(submittedAt),
      time: dateTime(submittedAt)
    };
  }
  function fetchUgcMedia(familyTag) {
    if (!familyTag) return Promise.resolve([]);
    var url = UGC_MEDIA_WORKER + '/api/ugc/media?family=' + encodeURIComponent(familyTag) +
      '&sort=priority_recent&limit=40';
    return fetchJson(url).then(function (data) {
      return data && Array.isArray(data.media) ? data.media : [];
    });
  }

  function initRoll(root) {
    var familyTag = root.getAttribute('data-family-code') || '';
    if (!familyTag) return;
    var scroll = root.querySelector('[data-pug-ugc-scroll]');

    fetchUgcMedia(familyTag)
      .then(function (media) {
        var items = [];
        var seen = {};
        (media || []).forEach(function (row) { pushUnique(items, seen, mediaToItem(row)); });
        if (!items.length) return; // adaptive none-tier: stay hidden

        items.forEach(function (it, i) {
          var t = document.createElement('button');
          t.type = 'button';
          t.className = 'pug-ut';
          t.setAttribute('aria-label', 'Open customer photo ' + (i + 1));
          t.innerHTML = '<img loading="lazy" src="' + sizeImg(it.photo, 520) + '" alt="Customer photo">';
          t.addEventListener('click', function () { openLightbox(items, i); });
          scroll.appendChild(t);
        });

        root.hidden = false; // reveal now that we have photos
      })
      .catch(function () {});
  }

  /* ---- lightbox ---- */
  var lb = {
    el: null, items: [], pos: 0,
    img: null, counter: null, starsEl: null, who: null, when: null, text: null
  };

  function bindLightbox() {
    lb.el = document.querySelector('[data-pug-lb]');
    if (!lb.el) return false;
    lb.img = lb.el.querySelector('[data-pug-lb-img]');
    lb.counter = lb.el.querySelector('[data-pug-lb-counter]');
    lb.starsEl = lb.el.querySelector('[data-pug-lb-stars]');
    lb.who = lb.el.querySelector('[data-pug-lb-who]');
    lb.when = lb.el.querySelector('[data-pug-lb-when]');
    lb.text = lb.el.querySelector('[data-pug-lb-text]');

    lb.el.querySelector('[data-pug-lb-close]').addEventListener('click', closeLightbox);
    lb.el.querySelector('[data-pug-lb-prev]').addEventListener('click', function () { step(-1); });
    lb.el.querySelector('[data-pug-lb-next]').addEventListener('click', function () { step(1); });
    lb.el.addEventListener('click', function (e) { if (e.target === lb.el) closeLightbox(); });
    document.addEventListener('keydown', function (e) {
      if (lb.el.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });
    return true;
  }

  function paint() {
    var it = lb.items[lb.pos];
    if (!it) return;
    lb.img.src = sizeImg(it.photo, 1280);
    lb.counter.textContent = (lb.pos + 1) + ' / ' + lb.items.length;
    lb.starsEl.textContent = stars(it.rating);
    lb.who.textContent = it.name;
    lb.when.textContent = it.date;
    lb.text.textContent = it.text;
    lb.el.querySelector('.pug-lb-side').scrollTop = 0;
  }
  function openLightbox(items, i) {
    if (!lb.el && !bindLightbox()) return;
    lb.items = items; lb.pos = i;
    paint();
    lb.el.hidden = false;
    lb.el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    lb.el.classList.remove('is-open');
    lb.el.hidden = true;
    document.body.style.overflow = '';
  }
  function step(d) {
    lb.pos = (lb.pos + d + lb.items.length) % lb.items.length;
    paint();
  }

  function boot() {
    bindLightbox();
    document.querySelectorAll('[data-pug-ugc]').forEach(initRoll);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
